import { render } from "./SizingComponent.vue?vue&type=template&id=036c8bf3"
import script from "./SizingComponent.vue?vue&type=script&lang=js"
export * from "./SizingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__